/**
 * TrialBalanceTable — renders the trial balance snapshot for the
 * dashboard's Trial Balance section, with a totals footer row so the
 * Debit/Credit balance can be eyeballed. Reuses VoucherTable's CSS classes.
 */

import React from 'react';
import './VoucherTable.css';
import './DrillDown.css';

const formatAmount = (amount) => {
  const n = Number(amount) || 0;
  if (n === 0) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(n);
};

const TrialBalanceTable = ({ rows = [], totals, openingTotals, loading = false, error = null, showCompany = false, onOpenLedger = null,level="primary" }) => {
  if (loading) {
    return <div className="vt-state vt-loading">Loading trial balance…</div>;
  }
  if (error) {
    return <div className="vt-state vt-error">Failed to load trial balance: {error}</div>;
  }
  if (!rows || rows.length === 0) {
    return <div className="vt-state vt-empty">No trial balance data for the current filters.</div>;
  }

  // Totals reflect every row matching the current filters (not just the
  // displayed page), so the Dr/Cr balance check stays accurate.
  const resolvedTotals = totals || rows.reduce(
    (acc, r) => {
      acc.debit += Number(r.closingDebit) || 0;
      acc.credit += Number(r.closingCredit) || 0;
      return acc;
    },
    { debit: 0, credit: 0 }
  );
    const profitLoss = resolvedTotals.credit - resolvedTotals.debit;

  return (
    <div className="voucher-table-wrap">
      {onOpenLedger && (
        <p className="dd-hint">Click any ledger to open its complete ledger view.</p>
      )}
      <table className="voucher-table">
        <thead>
          <tr>
            {/* <th>Ledger Name</th> */}
            <th>{level === "ledger" ? "Ledger" : "Group"}</th>
            {showCompany && <th>Company</th>}
            <th className="vt-amount-col">Closing Debit</th>
            <th className="vt-amount-col">Closing Credit</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr
              key={
    r.id ??
    r.groupName ??
    r.ledgerGuid
}
              className={onOpenLedger ? 'dd-clickable' : undefined}
              onClick={onOpenLedger ? () => onOpenLedger(r) : undefined}
              title={onOpenLedger ? 'Open the complete ledger view' : r.ledgerName}
            >
              {/* <td className="vt-party" title={r.ledgerName}>
                {onOpenLedger
                  ? <span className="dd-link">{r.ledgerName || '—'}</span>
                  : (r.ledgerName || '—')}
              </td> */}
<td
  className="vt-narration"
  title={r.type === "ledger" ? r.ledgerName : r.groupName}
>
  <span>
    {r.type === "ledger"
      ? (r.ledgerName || "—")
      : (r.groupName || "—")}
  </span>
  <span
    className={`tb-chip ${
      r.type === "ledger" ? "tb-chip-ledger" : "tb-chip-group"
    }`}
  >
    {r.type === "ledger" ? "Ledger" : "Group"}
  </span>

  
</td>            {showCompany && (
                <td className="vt-company" title={r.companyName}>{r.companyName || '—'}</td>
              )}
              <td className="vt-amount vt-out">
  {formatAmount(
    level === "primary"
      ? r.closingDebit
      : r.openingDebit
  )}
</td>

<td className="vt-amount vt-in">
  {formatAmount(
    level === "primary"
      ? r.closingCredit
      : r.openingCredit
  )}
</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
  {level === "primary" && (
    <>
      <tr>
        <td className="tb-total-label">
          Difference
        </td>

        <td className="vt-amount vt-out tb-total-value">
          {profitLoss > 0 ? formatAmount(profitLoss) : "-"}
        </td>

        <td className="vt-amount vt-in tb-total-value">
          {profitLoss < 0 ? formatAmount(Math.abs(profitLoss)) : "-"}
        </td>

        <td></td>
      </tr>

      <tr>
        <td className="tb-total-label">
          Total
        </td>

        <td className="vt-amount vt-out tb-total-value">
          {formatAmount(resolvedTotals.debit)}
        </td>

        <td className="vt-amount vt-in tb-total-value">
          {formatAmount(resolvedTotals.credit)}
        </td>

        <td></td>
      </tr>
    </>
  )}

  {level !== "primary" && (
    <tr>
      <td className="tb-total-label">
        Total
      </td>

      <td className="vt-amount vt-out tb-total-value">
    {formatAmount(openingTotals.debit)}
</td>

<td className="vt-amount vt-in tb-total-value">
    {formatAmount(openingTotals.credit)}
</td>

      <td></td>
    </tr>
  )}
</tfoot>
      </table>
    </div>
  );
};

export default TrialBalanceTable;
